module.exports = __webpack_public_path__ + "assets/img/tx102nt.8011f02a.jpg";